import { render, staticRenderFns } from "./stacked-bar-chart.vue?vue&type=template&id=de3ed82e&scoped=true"
import script from "./stacked-bar-chart.vue?vue&type=script&lang=js"
export * from "./stacked-bar-chart.vue?vue&type=script&lang=js"
import style0 from "./stacked-bar-chart.vue?vue&type=style&index=0&id=de3ed82e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de3ed82e",
  null
  
)

export default component.exports